const data = [
    {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/b74o3dilf8wf1-UZ/image;s=644x461",
        title: "вытяжка зонт масло держатель на",
        price: "260 у.е.",
        location: "Самарканд"
    },
    {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/jvfkakrrhl9f-UZ/image;s=644x461",
        title: "Одноразовые Стаканы",
        price: "90 сум",
        location: "Ташкент, Чиланзарский район",
    }, {
        img: "https://apollo-olx.cdnvideo.ru/v1/files/gp2t9won8h7i-UZ/image;s=644x461",
        title: "Однаразовая Посуда Оптом",
        price: "190 сум",
        location: "Ташкент, Чиланзарский район",
    },
]

export default data;